import styles from './index.module.scss';

export const CategoryTitle: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className={styles.titleContainer}>
      <h1 className={styles.title} data-testid="category-page-title">
        {text}
      </h1>
    </div>
  );
};

export const CategorySubTitle: React.FC<{ text: string }> = ({ text }) => {
  return <h2 className={styles.subTitle}>{text}</h2>;
};
